import { fork } from 'redux-saga/effects';

import * as login from './login';
import * as loginAzure from './login-azure';
import * as logout from './logout';
import * as signup from './signup/signup-req';
import * as resetPassword from './reset-password';
import * as createPassword from './create-password';
import * as userRegistration from './signup/user-registration-req';
import * as usernameAvailability from './signup/username-availability-req';
import * as sendInvitation from './send-invitation-req';
import * as sessionRefresh from './session-refresh-req';
import authSaga from './authSaga';
import logoutSaga from './logoutSaga';
import signUpSaga from './signup/signup-saga';
import loginRedirectSaga from './login-redirect-saga';
import changePasswordSaga from './changePassword/change-password-saga';
import expireSessionSaga from './expire-session-saga';
import userRegistrationSaga from './signup/user-registration-saga';
import { authAzureSaga } from './auth-azure-saga';
import { authAzureExternalRedirectSaga } from './authAzureExternalRedirectSaga';

export default function* authRootSaga() {
  yield fork(login.watcher);
  yield fork(loginAzure.watcher);
  yield fork(logout.watcher);
  yield fork(signup.watcher);
  yield fork(resetPassword.watcher);
  yield fork(createPassword.watcher);
  yield fork(userRegistration.watcher);
  yield fork(usernameAvailability.watcher);
  yield fork(sendInvitation.watcher);
  yield fork(sessionRefresh.watcher);
  yield fork(signUpSaga);
  yield fork(changePasswordSaga);
  yield fork(logoutSaga);
  yield fork(authSaga);
  yield fork(expireSessionSaga);
  yield fork(userRegistrationSaga);
  yield fork(loginRedirectSaga);
  yield fork(authAzureSaga);
  yield fork(authAzureExternalRedirectSaga);
}



// WEBPACK FOOTER //
// ./src/redux/auth/root-saga.js